import { WeeklyGrid } from './WeeklyGrid';
import { useDeleteScheduleMutation } from '../../api/schedules';
import type { ScheduleDoc } from '../../domain';

export function ScheduleCard({ doc, onEdit }: { doc: ScheduleDoc; onEdit: (doc: ScheduleDoc) => void }) {
  const del = useDeleteScheduleMutation();
  const label = doc.kind === 'setback'
    ? `Setback ${doc.setback_c?.toFixed(1)} °C on ${doc.target}`
    : `Solar schedule on ${doc.target}`;

  return (
    <div className="card">
      <div className="card-header">
        <strong>{label}</strong>
        <span className={`tag ${doc.active ? 'open' : 'closed'}`}>{doc.active ? 'active' : 'inactive'}</span>
      </div>
      <div style={{ margin: 'var(--sp-3) 0' }}>
        <WeeklyGrid intervals={doc.intervals} />
      </div>
      <div style={{ display: 'flex', gap: 'var(--sp-2)' }}>
        <button className="secondary" onClick={() => onEdit(doc)}>Edit</button>
        <button className="danger" disabled={del.isPending} onClick={() => del.mutate(doc.id)}>
          {del.isPending ? 'Deleting…' : 'Delete'}
        </button>
      </div>
      {del.isError && <div className="field-error">{(del.error as Error).message}</div>}
    </div>
  );
}
